import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito un diagnóstico médico para usar el Sistema?',
    a: 'No. El Volumen 1 incluye una guía de diagnóstico personal para arrancar desde el primer día.'
  }, {
    q: '¿Tengo que comprar productos importados o caros?',
    a: 'No. Todo se consigue en Coto, Carrefour, Jumbo o la dietética de tu barrio.'
  }, {
    q: '¿Cuánto tarda en funcionar?',
    a: 'La mayoría nota cambios entre el día 5 y el día 10 en inflamación, energía y sueño.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 21 días, devolución del 100%, sin preguntas ni formularios.'
  }, {
    q: '¿El producto es 100% digital?',
    a: 'Sí. En menos de 5 minutos tenés los 6 volúmenes y los 5 bonos en PDF listos para usar.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 bg-brand-black" data-id="element-94">
      <div className="container mx-auto px-4" data-id="element-95">
        <div className="max-w-3xl mx-auto" data-id="element-96">
          <div className="text-center mb-12" data-id="element-97">
            <h2 className="text-3xl md:text-4xl font-bold font-[Poppins,_sans-serif]" data-id="element-98">
              ❓PREGUNTAS FRECUENTES
            </h2>
          </div>

          <div className="space-y-4" data-id="element-99">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="border border-gray-800 rounded-xl overflow-hidden bg-brand-dark" data-id="element-100">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-101">
                  <span className="font-bold text-lg text-white pr-8" data-id="element-102">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-light shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-103" />
                </button>
                <AnimatePresence data-id="element-104">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-105">
                      <div className="p-6 pt-0 text-gray-300 leading-relaxed border-t border-gray-800/50 mt-2" data-id="element-106">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}